import { useQuery } from '@tanstack/react-query';
import { apiKeysAPI } from '../services/api';

/**
 * What an API key may be granted, from the server (`config/apiKeyPermissions.js`),
 * which refuses anything else on save. One list for the create and edit pages.
 */
export function useApiKeyPermissions() {
  const { data } = useQuery({
    queryKey: ['api-key-permissions'],
    queryFn: () => apiKeysAPI.permissions().then((r) => r.data.permissions),
    staleTime: 60 * 60 * 1000,
  });
  return data || [];
}
